<template>
    <q-card class="shadow-2">
        <q-tabs v-model="tab" class="text-grey" inline-label :breakpoint="0" active-color="primary"
            indicator-color="primary" align="justify">
            <q-tab name="estoque" label="Estoque" class="bg-white-4 text-primary"/>
            <q-tab name="informacao" label="Informações" class="bg-white-4 text-primary" />
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="estoque">
                <q-card>
                    <q-lins-table
                        id="tableEstoque"
                        ref="tableEstoque"
                        :keyField="'loja'"
                        :data-table="listaLojasEstoques"
                        :columns="columns"
                        :auto-load="false"
                        :pagination="false"
                        :expand="true"
                    >
                        <template v-slot:expand="props">
                            <q-lins-table
                                :id="`tabConsultaExpand${props.row.id}`"
                                :ref="`tabConsultaExpand${props.row.id}`"
                                :data-table="props.row.loja.produtos"
                                :columns="columnsExpandVariacao"
                                :auto-load="false"
                                :pagination="false"
                                :expand="true"
                                class="shadow-1"
                            >
                                <template v-slot:expand="props">
                                    <q-lins-table
                                        style="margin-left: 3rem;"
                                        :id="`tabConsultaExpandTam${props.row.id}`"
                                        :ref="`tabConsultaExpandTam${props.row.id}`"
                                        :data-table="props.row.tamanhos"
                                        :columns="columnsExpandTamanhos"
                                        :auto-load="false"
                                        :pagination="false" 
                                        class="shadow-1"
                                    />
                                </template>
                            </q-lins-table>
                        </template>
                    </q-lins-table>
                </q-card>
                <section class="row items-start justify-start ">
                    <q-btn icon="add" class="q-mt-sm" no-caps flat @click="abreDialogo">Outras lojas</q-btn>
                </section>
            </q-tab-panel>

            <q-tab-panel name="informacao">
                <q-tab-informacao :dados="produto" :listaProdutos="listaLojasEstoques"/>
            </q-tab-panel>
        </q-tab-panels>
        <q-modal-estoque-lojas ref="refModalBuscaEstoques" :dados="listaLojasEstoques"></q-modal-estoque-lojas>
    </q-card>
</template>
<script>
import { ref } from 'vue'
import QTabInformacao from './QTabInformacao.vue';
import QLinsTable from '@/shared/QLinsDrfTable.vue';
import QModalEstoqueLojas from '@/components/QModalEstoqueLojas.vue'

export default {
    name: 'QTabEstoque',
    components: {
        QTabInformacao,
        QLinsTable,
        QModalEstoqueLojas
    },
    props: {
        produto: {
            type: Object,
            default: null
        },
        listaLojasEstoques: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        const columns = ref([
            {
                name: "loja",
                field: 'loja',
                label: "Loja",
                align: "left",
                width: "20ch",
                format(value) {
                    return value.nome
                }
            },
            {
                name: "total",
                field: "loja",
                align: "center",
                label: "Total",
                format(value) {
                    return value.total
                }
            },
            {
                name: "em_loja",
                field: "loja",
                align: "center",
                label: "Em Loja",
                format(value) {
                    return value.em_loja
                }
            },
            {
                name: "condicional",
                field: "loja",
                align: "center",
                label: "Condicional",
                format(value) {
                    return value.condicional
                }
            },
            {
                name: "reservado",
                field: "loja",
                align: "center",
                label: "Reservado",
                format(value) {
                    return value.total_reserva
                }
            }
        ])
        const columnsExpandVariacao = ref([
            {
                name: "cor_predominante",
                field: "produtos",
                width: "28ch",
                label: "Cor",
                align: "left",
                format(value, row) {
                    const cor_predominante = row.cor_predominante
                    const cor_02 = row.cor_02 ? `/ ${row.cor_02}` : ''
                    const cor_03 = row.cor_03 ?  `/ ${row.cor_03}` : ''
                    return `${cor_predominante} ${cor_02} ${cor_03}`
                }
            },
            {
                name: "total",
                field: "produtos",
                label: "Total",
                format(value, row) {
                    return row.total
                }
            },
            {
                name: "em_loja",
                field: "produtos",
                label: "Em Loja",
                format(value, row) {
                    return row.em_loja
                }
            },
            {
                name: "condicional",
                field: "produtos",
                label: "Condicional",
                format(value, row) {
                    return row.est_condicional
                }
            },
            {
                name: "total_reservado",
                field: "produtos",
                label: "Reservado",
                format(value, row) {
                    return row.total_reservado
                }
            }
        ])
        const columnsExpandTamanhos = ref([
            {
                name: "tamanho",
                field: "produtos",
                width: "25ch",
                label: "Tamanho",
                align: "start",
                format(value, row) {
                    return row.cod_tamanho
                }
            },
            {
                name: "total",
                field: "produtos",
                label: "Total",
                align: "start",
                format(value, row) {
                    return row.qtd_loja + row.est_condicional + row.reservado
                }
            },
            {
                name: "em_loja",
                field: "produtos",
                label: "Em loja",
                align: "start",
                format(value, row) {
                    return row.qtd_loja 
                }
            },
            {
                name: "condicional",
                field: "produtos",
                label: "Condicional",
                align: "start",
                format(value, row) {
                    return row.est_condicional 
                }
            },
            {
                name: "reservado",
                field: "produtos",
                label: "Reservado",
                align: "start",
                format(value, row) {
                    return row.reservado 
                }
            }
        ])
        return {
            tab: ref('estoque'),
            columnsExpandTamanhos,
            columnsExpandVariacao,
            columns
        }
    },
    methods:{
        abreDialogo(){
            this.$q.dialog({
                title: 'Atenção',
                message: 'Esta busca será mais lenta e pode demorar. Você tem certeza que quer continuar?',
                ok: {
                    color: 'primary'
                },
                cancel: {
                    label:'Cancelar',
                    color:'orange-5',
                }
            }).onOk(() => {
                this.$refs.refModalBuscaEstoques.show()
            }).onCancel(() => {
            // console.log('Cancel')
            }).onDismiss(() => {
                // console.log('I am triggered on both OK and Cancel')
            })
        }
    }
}
</script>
<style>
.q-tabs__arrow {
    visibility: hidden;
}
</style>